import React, { useState } from "react";
import Select from "react-select";
import { FiUploadCloud } from "react-icons/fi";
import "../SheetUpload/SheetBulkUploadPopup.scss";
import { useDispatch, useSelector } from "react-redux";
import { LetterOnboardingBulkUploadSuccess } from "../../../Redux/Slice";
import { toast } from "react-toastify";
import * as XLSX from "xlsx";
import axios from "axios";
import { getLoaderAction } from "../../../Redux/Loader";
import { LetterOnboardingSampleSheetApi } from "../../../text/apidata";

const LetterOnboardingPopup = ({ setPopup }) => {
  const [file, setFile] = useState(null);
  const dispatch = useDispatch();
  const userSessionData = useSelector((state) => state?.users?.UserData);

  const options = [
    { value: "0", label: "Appointment Letter" },
    { value: "1", label: "Salary Revision" },
    { value: "2", label: "MW Revision" },
    { value: "3", label: "Salary Structure Revision" },
    { value: "4", label: "Contract Renewal" },
    { value: "5", label: "Poor Performance" },
    { value: "6", label: "PIP" },
    { value: "7", label: "Indiscipline" },
    { value: "8", label: "Absconding" },
    { value: "9", label: "False Attendance" },
    { value: "10", label: "False Bill Submission" },
    { value: "11", label: "Transfer Letter" },
    { value: "12", label: "Relieving Letter" },
    { value: "13", label: "Experience Letter" },
    { value: "14", label: "Relinquishment Letter" },
    { value: "15", label: "Designation Change Letter" },
    { value: "16", label: "Role Change Letter" },
  ];

  const [selectedOption, setSelectedOption] = useState(null);

  const allowedTypes = [
    "application/vnd.ms-excel",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  ];

  const MAX_SIZE = 250 * 1024 * 1024; // 250MB

  const validateFile = (uploadedFile) => {
    if (!uploadedFile) return false;

    if (!allowedTypes.includes(uploadedFile.type)) {
      toast.error("Only Excel files (.xls, .xlsx) are allowed");
      return false;
    }

    if (uploadedFile.size > MAX_SIZE) {
      toast.error("File size should be less than 250MB");
      return false;
    }

    return true;
  };

  const handleDrop = (e) => {
    e.preventDefault();
    const uploadedFile = e.dataTransfer.files[0];
    if (!validateFile(uploadedFile)) return;
    setFile(uploadedFile);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const handleFileChange = (e) => {
    const uploadedFile = e.target.files[0];
    if (!validateFile(uploadedFile)) return;
    setFile(uploadedFile);
  };

  const uploadFile = () => {
    if (!selectedOption || selectedOption.value === undefined || selectedOption.value === null) {
      toast.error("Please select a letter type");
      return;
    }

    if (!file) {
      toast.error("Please select a file");
      return;
    }

    const payload = {
      report_type: selectedOption.value,
      file: file,
      setPopup,
    };

    dispatch(LetterOnboardingBulkUploadSuccess(payload));
  };

  const downloadSample = async () => {
    if (!selectedOption || selectedOption.value === undefined || selectedOption.value === null) {
      toast.error("Please select a letter type first");
      return;
    }

    try {
      getLoaderAction(true);
      const token = userSessionData?.session?.token;
      const response = await axios({
        method: "get",
        url: LetterOnboardingSampleSheetApi,
        params: {
          report_type: selectedOption.value,
        },
        headers: {
          Authorization: "Bearer " + token,
        },
      });

      getLoaderAction(false);

      // Check if file URL is returned directly
      const fileUrl =
        response?.data?.file_url ||
        response?.data?.url ||
        response?.data?.data?.url;
      if (fileUrl) {
        window.open(fileUrl, "_blank");
        return;
      }

      // Extract field headers array from response
      const rawData = response?.data;
      let fields = [];

      if (Array.isArray(rawData)) {
        fields = rawData;
      } else if (rawData?.fields && Array.isArray(rawData.fields)) {
        fields = rawData.fields;
      } else if (rawData?.data && Array.isArray(rawData.data)) {
        fields = rawData.data;
      } else if (rawData?.status?.data && Array.isArray(rawData.status.data)) {
        fields = rawData.status.data;
      } else if (typeof rawData === "object" && rawData !== null) {
        fields = Object.keys(rawData);
      }

      if (fields.length > 0) {
        const ws = XLSX.utils.aoa_to_sheet([fields]);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Sample");
        const filename = `${selectedOption.label.replace(/[^a-zA-Z0-9]/g, "_")}_Sample.xlsx`;
        XLSX.writeFile(wb, filename);
      } else {
        toast.error("No sample sheet fields found for the selected option");
      }
    } catch (error) {
      getLoaderAction(false);
      toast.error(
        error?.response?.data?.status?.message ||
          error?.response?.data?.message ||
          "Failed to fetch sample sheet"
      );
    }
  };

  return (
    <div className="overlay">
      <div className="popupContainers">
        {/* Header */}
        <div className="popupHeader">
          <div />
          <span className="TitleHeader">Letter Onboarding Bulk Upload</span>
          <button className="closeButton" onClick={() => setPopup(false)}>
            ×
          </button>
        </div>

        {/* Dropdown & Sample Sheet */}
        <div
          className="uploadTypeHeader"
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "15px",
            gap: "10px",
          }}
        >
          <div style={{ width: "280px" }}>
            <Select
              options={options}
              value={selectedOption}
              onChange={(val) => setSelectedOption(val)}
              placeholder="Select Letter Type..."
              isClearable={false}
            />
          </div>

          <button
            className="sampleSheetBtn"
            onClick={downloadSample}
            style={{ textWrap: "nowrap", width: "35%" }}
          >
            Sample Sheet
          </button>
        </div>

        {/* Drag & Drop */}
        <div
          className="uploadBox"
          onDrop={handleDrop}
          onDragOver={handleDragOver}
        >
          <FiUploadCloud className="uploadIcon" />

          <p className="mainText">
            Click to select or drag & drop your Excel file
          </p>

          <p className="subText">Supported formats: .xls, .xlsx</p>
          <p className="subText">Max file size 250MB</p>

          <input type="file" onChange={handleFileChange} accept=".xls,.xlsx" />

          {file && <p className="fileName">{file.name}</p>}
        </div>

        {/* Footer Buttons */}
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: "12px",
            marginTop: "20px",
          }}
        >
          <button
            style={{
              padding: "9px 22px",
              background: "#fff",
              border: "1px solid #d0d5dd",
              borderRadius: "8px",
              color: "#344054",
              fontWeight: "600",
              fontSize: "14px",
              cursor: "pointer",
              transition: "all 0.2s ease",
            }}
            onClick={() => setPopup(false)}
          >
            Cancel
          </button>

          <button
            className="submitBtn"
            style={{
              margin: 0,
              width: "auto",
              padding: "9px 24px",
              fontSize: "14px",
            }}
            disabled={!file || !selectedOption}
            onClick={uploadFile}
          >
            Upload File
          </button>
        </div>
      </div>
    </div>
  );
};

export default LetterOnboardingPopup;
